/* eslint-disable max-len */
import { TFunction } from 'i18next';

export const getStreamSectionInfo = (
  t: TFunction<'translation', undefined>,
) => ({
  sectionInfo: t(
    'Here you will find your class activity. Click “See All” to view your activity since the beginning of the school year. There, you can also filter by class if you have multiple classes.',
  ),
  sectionInfoNoSeeAll: t(
    'Here you will find your class activity. After you have taught your first four lessons, a “See All” button will appear where you can view your activity since the beginning of the school year. There, you can also filter by class if you have multiple classes.',
  ),
});

export const MAIN_PAGE_INIT_ITEMS_COUNT = 4;

export const STREAM_ITEMS_LIMIT_PER_QUERY = 10;
export const MAIN_PAGE_ITEMS_LIMIT_PER_QUERY = 10;

export const STREAM_CONTENT_REFRESH_INTERVAL = 60000 * 3;
